module.exports = __webpack_public_path__ + "static/media/31-2.3de1f3e7.mp3";